import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation createHolidayCalendarMutation($input: CreateHolidayCalendarInput!) {
		createHolidayCalendar(input: $input) {
			holidayCalendar {
				node {
					...settingsHolidayCalendars_HolidayCalendar
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [
				{
					key: 'Company_holidayCalendars',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'holidayCalendar',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Holiday calendar created');
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), name: input.name}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
